import { render } from "./ProjectPermActivate.vue?vue&type=template&id=61aebe5e&scoped=true"
import script from "./ProjectPermActivate.vue?vue&type=script&lang=js"
export * from "./ProjectPermActivate.vue?vue&type=script&lang=js"

import "./ProjectPermActivate.vue?vue&type=style&index=0&id=61aebe5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aebe5e"]])

export default __exports__